module.exports = __webpack_public_path__ + "img/fibi.c62b139a.svg";